var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNavMoniter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_81_2402)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_81_2402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 11C20.5531 11 21 11.4469 21 12V14H24.75C25.9937 14 27 15.0062 27 16.25V24.75C27 25.9937 25.9937 27 24.75 27H15.25C14.0062 27 13 25.9937 13 24.75V16.25C13 15.0062 14.0062 14 15.25 14H19V12C19 11.4469 19.4469 11 20 11ZM16.5 23C16.225 23 16 23.225 16 23.5C16 23.775 16.225 24 16.5 24H17.5C17.775 24 18 23.775 18 23.5C18 23.225 17.775 23 17.5 23H16.5ZM19.5 23C19.225 23 19 23.225 19 23.5C19 23.775 19.225 24 19.5 24H20.5C20.775 24 21 23.775 21 23.5C21 23.225 20.775 23 20.5 23H19.5ZM22.5 23C22.225 23 22 23.225 22 23.5C22 23.775 22.225 24 22.5 24H23.5C23.775 24 24 23.775 24 23.5C24 23.225 23.775 23 23.5 23H22.5ZM18.25 19C18.25 18.6685 18.1183 18.3505 17.8839 18.1161C17.6495 17.8817 17.3315 17.75 17 17.75C16.6685 17.75 16.3505 17.8817 16.1161 18.1161C15.8817 18.3505 15.75 18.6685 15.75 19C15.75 19.3315 15.8817 19.6495 16.1161 19.8839C16.3505 20.1183 16.6685 20.25 17 20.25C17.3315 20.25 17.6495 20.1183 17.8839 19.8839C18.1183 19.6495 18.25 19.3315 18.25 19ZM23 20.25C23.3315 20.25 23.6495 20.1183 23.8839 19.8839C24.1183 19.6495 24.25 19.3315 24.25 19C24.25 18.6685 24.1183 18.3505 23.8839 18.1161C23.6495 17.8817 23.3315 17.75 23 17.75C22.6685 17.75 22.3505 17.8817 22.1161 18.1161C21.8817 18.3505 21.75 18.6685 21.75 19C21.75 19.3315 21.8817 19.6495 22.1161 19.8839C22.3505 20.1183 22.6685 20.25 23 20.25ZM11.5 18H12V24H11.5C10.6719 24 10 23.3281 10 22.5V19.5C10 18.6719 10.6719 18 11.5 18ZM28.5 18C29.3281 18 30 18.6719 30 19.5V22.5C30 23.3281 29.3281 24 28.5 24H28V18H28.5Z",
    fill: "#6B7280"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_81_2402",
    x: -2,
    y: -1,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_81_2402"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_81_2402",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_2402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16,
    fill: "white",
    transform: "translate(10 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNavMoniter);
export default __webpack_public_path__ + "static/media/ic_nav_moniter.90b1110eb793a39b9b36963f5024eba4.svg";
export { ForwardRef as ReactComponent };